const positionToNameDict = {
  'P': 'Pitcher',
  'C': 'Catcher',
  '1B': 'First Base',
  '2B': 'Second Base',
  '3B': 'Third Base',
  'SS': 'Shortstop',
  'OF': 'Outfield',
  'QB': 'Quarterback',
  'RB': 'Running Back',
  'WR': 'Wide Receiver',
  'TE': 'Tight End',
  'K': 'Kicker',
  'PG': 'Point Guard',
  'SG': 'Shooting Guard',
  'SF': 'Small Forward',
  'PF': 'Power Forward',
  'F': 'Forward',
}

export default positionToNameDict